<script lang="ts">
  import ConversationList from '../../components/messages/ConversationList.svelte';
  import MessageThread from '../../components/messages/MessageThread.svelte';
  import NewMessageDialog from '../../components/messages/NewMessageDialog.svelte';
  import { messages, type Conversation } from '../../stores/messages';

  interface Props {
    currentUserId: string;
  }

  let { currentUserId }: Props = $props();

  let selectedConversation = $state<Conversation | null>(null);
  let newMessageOpen = $state(false);
  let isStartingConversation = $state(false);

  function handleSelectConversation(conversation: Conversation) {
    selectedConversation = conversation;
  }

  async function handleStartConversation(userId: string | number) {
    isStartingConversation = true;
    try {
      const conversation = await messages.startConversation(userId);
      if (conversation) {
        selectedConversation = conversation;
        newMessageOpen = false;
      }
    } finally {
      isStartingConversation = false;
    }
  }
</script>

<svelte:head>
  <title>메시지 | AX Admin</title>
</svelte:head>

<div class="space-y-6">
  <div>
    <div class="flex items-start justify-between gap-4 mb-6">
      <div>
        <h1 class="text-h1 text-content">메시지</h1>
        <p class="mt-2 text-body2 text-content-tertiary">대화를 선택하거나 새 메시지를 시작하세요.</p>
      </div>
    </div>

    <div class="card overflow-hidden">
      <div class="flex flex-col lg:flex-row min-h-[70vh]">
        <!-- Conversation List -->
        <div class="lg:w-80 border-b lg:border-b-0 lg:border-r border-default bg-surface">
          <ConversationList
            selectedId={selectedConversation?.id}
            onSelect={handleSelectConversation}
            onNewMessage={() => (newMessageOpen = true)}
          />
        </div>

        <!-- Message Thread -->
        <div class="flex-1 bg-gray-50 dark:bg-dark-primary">
          {#if selectedConversation}
            <MessageThread
              conversationId={selectedConversation.id}
              {currentUserId}
              onClosed={() => (selectedConversation = null)}
            />
          {:else}
            <div class="h-full flex items-center justify-center text-content-tertiary p-10">
              <div class="text-center max-w-sm">
                <svg class="w-20 h-20 mx-auto mb-4 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                        d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
                <p class="text-h2 text-content">대화를 선택해주세요</p>
                <p class="text-body2 mt-2">왼쪽 목록에서 대화를 선택하거나, 위의 <strong>새 메시지</strong> 버튼으로 대화를 시작하세요.</p>
                <button type="button" class="btn btn-primary btn-md mt-4 inline-flex items-center gap-1" onclick={() => (newMessageOpen = true)}>
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                  </svg>
                  새 메시지 시작하기
                </button>
              </div>
            </div>
          {/if}
        </div>
      </div>
    </div>
  </div>
</div>

<NewMessageDialog
  bind:open={newMessageOpen}
  onClose={() => (newMessageOpen = false)}
  onStarted={handleStartConversation}
  isStarting={isStartingConversation}
/>
